module.exports = __webpack_public_path__ + "81cf7ce9d315e3bb2ed237887b43dc58.pdf";